module.exports = __webpack_public_path__ + "static/media/blue-preview.4df668ac.svg";